import { BehaviorSubject } from 'rxjs';
import axios from "axios";
import  {API_BASE_URL} from '../../redux/constants/index';


import { HandleResponse } from '../_helpers';

//const CurrentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export const AuthenticationService = {
    login,
    logout,
  // currentUser: CurrentUserSubject.asObservable(),
  // get currentUserValue () { return CurrentUserSubject.value }
};

// function  login(username, password) {
//     debugger
//     const requestOptions = {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ username, password })
//     };

//     return fetch(`/users/authenticate`, requestOptions)
//         .then(HandleResponse)
//         .then(user => {
//             // store user details and jwt token in local storage to keep user logged in between page refreshes
//             localStorage.setItem('currentUser', JSON.stringify(user));
//             CurrentUserSubject.next(user);

//             return user;
//         });
// }


async function  login(username, password, rememberMe = false) {
    debugger; 
    return await axios.post(API_BASE_URL +"Login/Login", {
        userName: username,
        password: password,
        rememberme: rememberMe
      })
      .then( response =>{
        if(response.data.status == true)
        {
          // Store user data in appropriate storage based on rememberMe
          if (rememberMe) {
            localStorage.setItem("emr_menu", JSON.stringify(response.data.data));
            localStorage.setItem("emr_user", JSON.stringify(response.data.data1));
            localStorage.setItem("emr_hospital_info", JSON.stringify(response.data.hospital));
          } else {
            sessionStorage.setItem("emr_menu", JSON.stringify(response.data.data));
            sessionStorage.setItem("emr_user", JSON.stringify(response.data.data1));
            sessionStorage.setItem("emr_hospital_info", JSON.stringify(response.data.hospital));
          }

          return response.data;
        }
        else{
          throw new Error(response.data.message || "Login failed");
        }
      })
      .catch(error => {
        console.error("Login error:", error);
        throw error;
      });
  }



function logout() {
  try {
    // Clear all stored data including remembered user data
    localStorage.removeItem('emr_menu');
    localStorage.removeItem('emr_user');
    localStorage.removeItem("emr_hospital_info");
    localStorage.removeItem("emr_remembered_user");
    
    // Also clear session storage
    sessionStorage.removeItem('emr_menu');
    sessionStorage.removeItem('emr_user');
    sessionStorage.removeItem("emr_hospital_info");
    
    // Clear any other potential stored data
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('currentUser');
    
    // Set flag to prevent auto-login after logout
    sessionStorage.setItem('just_logged_out', 'true');
    
  } catch (error) {
    console.error('Error during logout:', error);
  }
}
